<template>
    <div class="profile-form bg-white p-3 rounded">
        <h5 class="font-weight-bold mt-2 f-20 text-left mb-3">{{ $t('profileSettings.title') }}</h5>
        <h6 class="font-weight-bold text-left">{{ $t('profileSettings.emailNotifications') }}</h6>
        <b-row>
            <b-col lg="9" md="12" sm="12" class="text-left d-flex align-items-center justify-content-between gap-3">
                <div>
                    <label class="text-left w-fit-content mb-0">{{ $t('profileSettings.expiryData') }}</label>
                    <p class="mb-0 text-grey f-12">{{ $t('profileSettings.expiryDataDesc') }}</p>
                </div>
                <div class="text-left w-100px" v-if="user.team_member.email_expiry_date">
                    <b-form-select v-model="user.team_member.expiration_alert_days" :options="[
                        {
                            value: 15,
                            text: '15',
                        },
                        {
                            value: 30,
                            text: '30',
                        },
                        {
                            value: 45,
                            text: '45',
                        },
                        {
                            value: 60,
                            text: '60',
                        },
                    ]
                        " />
                </div>
                <b-form-checkbox v-model="user.team_member.email_expiry_date" name="check-button" switch size="lg"
                    class="ml-0-6rem"></b-form-checkbox>
            </b-col>
            <b-col lg="9" md="12" sm="12">
                <hr class="w-98 mt-2" />
            </b-col>
            <b-col lg="9" md="12" sm="12" class="text-left d-flex align-items-center justify-content-between">
                <div>
                    <label class="text-left w-fit-content mb-0">{{ $t('profileSettings.requiredDocs') }}</label>
                    <p class="mb-0 text-grey f-12">{{ $t('profileSettings.requiredDocsDesc') }}</p>
                </div>
                <b-form-checkbox v-model="user.team_member.email_missing_required_docs" name="check-button" switch size="lg"
                    class="ml-0-6rem"></b-form-checkbox>
            </b-col>
            <b-col lg="9" md="12" sm="12">
                <hr class="w-98 mt-2" />
            </b-col>
            <b-col lg="9" md="12" sm="12" class="text-left d-flex align-items-center justify-content-between">
                <div>
                    <label class="text-left w-fit-content mb-0">{{ $t('profileSettings.documentAdded') }}</label>
                    <p class="mb-0 text-grey f-12">{{ $t('profileSettings.documentAddedDesc') }}</p>
                </div>
                <b-form-checkbox v-model="user.team_member.get_document_added_email" name="check-button" switch size="lg"
                    class="ml-0-6rem"></b-form-checkbox>
            </b-col>
            <b-col lg="9" md="12" sm="12">
                <hr class="w-98 mt-2" />
            </b-col>
            <b-col lg="9" md="12" sm="12" class="text-left d-flex align-items-center justify-content-between">
                <div>
                    <label class="text-left w-fit-content mb-0">{{ $t('profileSettings.dotMode') }}</label>
                    <p class="mb-0 text-grey f-12">{{ $t('profileSettings.dotModeDesc') }}</p>
                </div>
                <b-form-checkbox v-model="user.team_member.get_driver_dot_mode_email" name="check-button" switch size="lg"
                    class="ml-0-6rem"></b-form-checkbox>
            </b-col>
            <b-col lg="9" md="12" sm="12">
                <hr class="w-98 mt-2" />
            </b-col>
            <b-col lg="9" md="12" sm="12" class="text-left d-flex align-items-center justify-content-between">
                <div>
                    <label class="text-left w-fit-content mb-0">{{ $t('profileSettings.taggedInNotes') }}</label>
                    <p class="mb-0 text-grey f-12">{{ $t('profileSettings.taggedInNotesDesc') }}</p>
                </div>
                <b-form-checkbox v-model="user.team_member.get_tagged_in_notes_email" name="check-button" switch size="lg"
                    class="ml-0-6rem"></b-form-checkbox>
            </b-col>
            <b-col lg="9" md="12" sm="12">
                <hr class="w-98 mt-2" />
            </b-col>
              <b-col lg="9" md="12" sm="12" class="text-left d-flex align-items-center justify-content-between">
                <div>
                    <label class="text-left w-fit-content mb-0">{{ $t('profileSettings.birthdayReminder') }}</label>
                    <p class="mb-0 text-grey f-12">{{ $t('profileSettings.birthdayReminderDesc') }}</p>
                </div>
                <b-form-checkbox v-model="user.team_member.birthday_reminders" name="check-button" switch size="lg"
                    class="ml-0-6rem"></b-form-checkbox>
            </b-col>
            <b-col lg="9" md="12" sm="12">
                <hr class="w-98 mt-2" />
            </b-col>
            <b-col lg="9" md="12" sm="12" class="text-left d-flex align-items-center justify-content-between">
                <div>
                    <label class="text-left w-fit-content mb-0">{{ $t('profileSettings.workAnniversaryReminder') }}</label>
                    <p class="mb-0 text-grey f-12">{{ $t('profileSettings.workAnniversaryReminderDesc') }}</p>
                </div>
                <b-form-checkbox v-model="user.team_member.work_anniversary_reminders" name="check-button" switch size="lg"
                    class="ml-0-6rem"></b-form-checkbox>
            </b-col>
            <b-col lg="9" md="12" sm="12">
                <hr class="w-98 mt-2" />
            </b-col>
            <b-col lg="9" md="12" sm="12" class="text-left d-flex align-items-center justify-content-between">
                <div>
                    <label class="text-left w-fit-content mb-0">{{ $t('profileSettings.formNotification') }}</label>
                    <p class="mb-0 text-grey f-12">{{ $t('profileSettings.formNotificationDesc') }}</p>
                </div>
                <b-form-checkbox v-model="user.team_member.get_form_submitted_email" name="check-button" switch size="lg"
                    class="ml-0-6rem"></b-form-checkbox>
            </b-col>
            <b-col lg="9" md="12" sm="12">
                <hr class="w-98 mt-2" />
            </b-col>
            <b-col lg="9" md="12" sm="12" class="text-left d-flex align-items-center justify-content-between">
                <div>
                    <label class="text-left w-fit-content mb-0">{{ $t('profileSettings.dvirNotification') }}</label>
                    <p class="mb-0 text-grey f-12">{{ $t('profileSettings.dvirNotificationDesc') }}</p>
                </div>
                <b-form-checkbox v-model="user.team_member.get_dvir_defect_email" name="check-button" switch size="lg"
                    class="ml-0-6rem"></b-form-checkbox>
            </b-col>
            <b-col lg="9" md="12" sm="12">
                <hr class="w-98 mt-2" />
            </b-col>
            <b-col lg="9" md="12" sm="12" class="text-left d-flex align-items-center justify-content-between">
                <div>
                    <label class="text-left w-fit-content mb-0">{{ $t('profileSettings.emailMaintenanceNotification') }}</label>
                    <p class="mb-0 text-grey f-12">{{ $t('profileSettings.emailMaintenanceNotificationDesc') }}</p>
                </div>
                <b-form-checkbox v-model="user.team_member.email_maintenance_schedule" name="check-button" switch size="lg"
                    class="ml-0-6rem"></b-form-checkbox>
            </b-col>
            <b-col lg="9" md="12" sm="12">
                <hr class="w-98 mt-2" />
            </b-col>
            <b-col lg="9" md="12" sm="12" class="text-left d-flex align-items-center justify-content-between">
                <div>
                    <label class="text-left w-fit-content mb-0">{{ $t('profileSettings.jobApplication') }}</label>
                    <p class="mb-0 text-grey f-12">{{ $t('profileSettings.jobApplicationDesc') }}</p>
                </div>
                <b-form-checkbox v-model="user.team_member.enable_new_recruit_notifications" name="check-button" switch size="lg"
                    class="ml-0-6rem"></b-form-checkbox>
            </b-col>
            <b-col lg="9" md="12" sm="12">
                <hr class="w-98 mt-2" />
            </b-col>
        </b-row>
        <h6 class="font-weight-bold text-left my-3">{{ $t('profileSettings.pushNotifications') }}</h6>
        <b-row>
            <b-col lg="9" md="12" sm="12" class="text-left d-flex align-items-center justify-content-between">
                <div>
                    <label class="text-left w-fit-content mb-0">{{ $t('profileSettings.documentAdded') }}</label>
                    <p class="mb-0 text-grey f-12">{{ $t('profileSettings.pushDocumentAddedDesc') }}</p>
                </div>
                <b-form-checkbox v-model="user.team_member.get_document_added_notification" name="check-button" switch
                    size="lg" class="ml-0-6rem"></b-form-checkbox>
            </b-col>
            <b-col lg="9" md="12" sm="12">
                <hr class="w-98 mt-2" />
            </b-col>
            <b-col lg="9" md="12" sm="12" class="text-left d-flex align-items-center justify-content-between">
                <div>
                    <label class="text-left w-fit-content mb-0">{{ $t('profileSettings.dotMode') }}</label>
                    <p class="mb-0 text-grey f-12">{{ $t('profileSettings.pushDotModeDesc') }}</p>
                </div>
                <b-form-checkbox v-model="user.team_member.get_driver_dot_mode_notification" name="check-button" switch
                    size="lg" class="ml-0-6rem"></b-form-checkbox>
            </b-col>
            <b-col lg="9" md="12" sm="12">
                <hr class="w-98 mt-2" />
            </b-col>
        </b-row>
        <div class="d-flex align-items-center flex-wrap">
            <b-button to="/" class="mx-0 h-40px w-100px mt-3 mr-3 m-0" variant="secondary">{{ $t('profileSettings.close') }}</b-button>
            <b-button v-if="hasChanged" @click="updateUserDetails()" class="mt-3 save h-40px w-100px m-0" variant="primary"
                type="button">{{ $t('profileSettings.save') }}</b-button>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { checkValueExists } from '../../services/helper';
export default {
    name: "Settings",
    data() {
        return {
            defaultData: {},
            checkValueExists
        }
    },
    computed: {
        ...mapGetters(["user"]),
        hasChanged() {
            return Object.keys(this.defaultData).filter(field => this.checkValueExists(this.user.team_member[field]) != this.checkValueExists(this.defaultData[field])).length > 0
        }
    },
    methods: {
        ...mapActions(['setNotification', 'updateTeamMember', 'getUserByID']),
        async updateUserDetails() {
            try {
                await this.updateTeamMember({
                    id: this.user.team_member.id,
                    payload: {
                        email_expiry_date: this.user.team_member.email_expiry_date,
                        get_document_added_email: this.user.team_member.get_document_added_email,
                        get_driver_dot_mode_email: this.user.team_member.get_driver_dot_mode_email,
                        get_document_added_notification: this.user.team_member.get_document_added_notification,
                        get_driver_dot_mode_notification: this.user.team_member.get_driver_dot_mode_notification,
                        get_tagged_in_notes_email: this.user.team_member.get_tagged_in_notes_email,
                        email_missing_required_docs: this.user.team_member.email_missing_required_docs,
                        expiration_alert_days: Number(this.user.team_member.expiration_alert_days),
                        birthday_reminders: this.user.team_member.birthday_reminders,
                        work_anniversary_reminders: this.user.team_member.work_anniversary_reminders,
                        enable_new_recruit_notifications: this.user.team_member.enable_new_recruit_notifications,
                        get_form_submitted_email: this.user.team_member.get_form_submitted_email,
                        get_dvir_defect_email: this.user.team_member.get_dvir_defect_email,
                        email_maintenance_schedule: this.user.team_member.email_maintenance_schedule
                    },
                });
                await this.setNotification({
                    msg: this.$t('profileSettings.userUpdated'),
                    type: "success",
                    color: "green",
                });
                this.setDefaultData()
                await this.getUserByID()
                this.errors = {
                    phone: null,
                };
            } catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                }
            }
        },
        setDefaultData() {
            this.defaultData = {
                email_expiry_date: this.user.team_member.email_expiry_date,
                get_document_added_email: this.user.team_member.get_document_added_email,
                get_driver_dot_mode_email: this.user.team_member.get_driver_dot_mode_email,
                get_document_added_notification: this.user.team_member.get_document_added_notification,
                get_driver_dot_mode_notification: this.user.team_member.get_driver_dot_mode_notification,
                get_tagged_in_notes_email: this.user.team_member.get_tagged_in_notes_email,
                email_missing_required_docs: this.user.team_member.email_missing_required_docs,
                expiration_alert_days: Number(this.user.team_member.expiration_alert_days),
                birthday_reminders: this.user.team_member.birthday_reminders,
                work_anniversary_reminders: this.user.team_member.work_anniversary_reminders,
                enable_new_recruit_notifications: this.user.team_member.enable_new_recruit_notifications,
                get_form_submitted_email: this.user.team_member.get_form_submitted_email,
                get_dvir_defect_email: this.user.team_member.get_dvir_defect_email,
                email_maintenance_schedule: this.user.team_member.email_maintenance_schedule

            }
        }
    },
    mounted() {
        this.setDefaultData()
    }
}
</script>